export const environment = {
  production: false,
    firebase: {
    apiKey: "AIzaSyDszh9YV8wLG5FusyHxXrJiLBhUG-8c2jI",
    authDomain: "cp-ecommerce.firebaseapp.com",
    projectId: "cp-ecommerce",
    storageBucket: "cp-ecommerce.appspot.com",
    messagingSenderId: "501000639555",
    appId: "1:501000639555:web:826dc2bb4d6fc39a7e30f6"
    }
};


